module.exports = __webpack_public_path__ + "static/logo-creative-industries-nl-fd33c459233886c820b1487206522791.jpg";